import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import ResponsiveCDNImage from "../../../components/common/image/responsive-cdn-image";
import BACK_IMG from "../../../components/common/back-img.png";

interface PackHeaderProps {
  storeImg: string | null | undefined;
  storeTitle: string | null | undefined;
  titleSuffix: string;
  loading: boolean;
}

const PackHeader = ({
  storeImg,
  storeTitle,
  titleSuffix,
  loading,
}: PackHeaderProps) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="relative w-full">
        <img
          src={BACK_IMG}
          alt="back"
          onClick={() => navigate(-1)}
          className="absolute top-5 left-5 w-[40px] h-[40px] z-10"
        />

        <div className="w-full h-56">
          {loading ? (
            <Skeleton
              style={{ height: 224, width: "100%", lineHeight: 2 }}
            />
          ) : (
            <ResponsiveCDNImage
              src={storeImg || ""}
              alt={storeTitle || ""}
              className="w-full h-56 object-cover"
            />
          )}
        </div>
      </div>

      <div className="px-4 py-3">
        <div className="flex flex-col mb-3 space-y-2">
          {loading ? (
            <Skeleton style={{ height: 31, width: 200 }} />
          ) : (
            <h2 className="text-3xl font-semibold text-black">
              {storeTitle} {titleSuffix}
            </h2>
          )}
        </div>
      </div>
    </>
  );
};

export default PackHeader;
